import { useAppLoader } from '@capsicum/common';
import { useCallback } from 'react';

import { type EmailGenerateCodeParams, type MobileNumberGenerateCodeParams } from '../models';

import { useSendVerificationCode } from './useSendVerificationCode';

type UseSendCodeBySMSCallbackProps =
	| {
			data: EmailGenerateCodeParams;
			type: 'email';
	  }
	| {
			data: MobileNumberGenerateCodeParams;
			type: 'phone-number';
	  };

export const useSendCodeByWhatsapp = () => {
	const loader = useAppLoader();
	const { sendWhatsappCodeByEmailToUser, sendWhatsappCodeByPhoneNumberToUser } = useSendVerificationCode();

	return useCallback(
		({ data, type }: UseSendCodeBySMSCallbackProps) => {
			return loader(
				type === 'phone-number'
					? sendWhatsappCodeByPhoneNumberToUser({
							attempt: data.attempt,
							captchaInformation: data.captchaInformation,
							countryCode: data.countryCode,
							mobileNumber: data.mobileNumber
						})
					: sendWhatsappCodeByEmailToUser({
							attempt: data.attempt,
							captchaInformation: data.captchaInformation,
							email: data.email
						})
			);
		},
		[loader, sendWhatsappCodeByEmailToUser, sendWhatsappCodeByPhoneNumberToUser]
	);
};
